import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// R4 B5: tell the server which screen made the call (VAT flip log).
api.interceptors.request.use((config) => {
  config.headers = config.headers || {};
  config.headers["X-Lyra-Screen"] = `${window.location.pathname}${window.location.search}`.slice(0, 200);
  return config;
});

// R11: server says this needs approval -> offer to send it to the Approvals inbox.
const r11Handler = async (error) => {
  const d = error?.response?.data?.detail;
  if (error?.response?.status === 428 && d?.error === "approval_required") {
    error.response.data.detail = d.message;
    const cfg = error.config || {};
    const u = new URL(cfg.url.startsWith("http") ? cfg.url : `${API}${cfg.url.startsWith("/") ? "" : "/"}${cfg.url}`);
    const q = new URLSearchParams(u.search);
    Object.entries(cfg.params || {}).forEach(([k, v]) => { if (v !== undefined && v !== null && v !== "") q.set(k, v); });
    let body = cfg.data;
    try { body = typeof body === "string" ? JSON.parse(body) : body; } catch { body = null; }
    const { toast } = await import("sonner");
    toast.info(`${d.label}: this needs approval.`, {
      duration: 12000,
      action: { label: "Send to approval", onClick: () => api.post("/r11/approvals", {
        method: (cfg.method || "post").toUpperCase(), path: u.pathname, query: q.toString() || null,
        body: body && typeof body === "object" && !(body instanceof FormData) ? body : null,
        summary: `${d.label}: ${(cfg.method || "post").toUpperCase()} ${u.pathname.replace(/^\/api/, "")}`,
      }).then(() => toast.success("Sent to the Approvals inbox")).catch(() => toast.error("Could not send to approval")) },
    });
    error.r11Handled = true;
  } else if (error?.response?.status === 403 && d?.error === "not_allowed") {
    error.response.data.detail = `Your role (${d.role}) cannot do this.`;
  }
  return Promise.reject(error);
};
api.interceptors.response.use(undefined, r11Handler);
axios.interceptors.response.use(undefined, r11Handler);
